// extracted by mini-css-extract-plugin
export var primary = "styles-module--primary--56395";
export var secondary = "styles-module--secondary--213ab";